export const ANALYTICS = "analytics";
export const CUSTOM = "custom";
export const PROFILES = "profiles";
export const REPORTS = "reports";
